/**
 * O total centralizado no alto dos cartões de folha do Fechamento.
 *
 * Papel: reproduz o bloco de "Total do mês", "Despesas" e "Despesas com Pessoal"
 * (l. 640–643, 663–666, 692–695): o rótulo em 10 px, caixa alta, `.5px` e
 * `texto-fraco`, e o valor em 22 px, peso 800, com 10 px abaixo do bloco.
 */

interface TotalEmDestaqueProps {
  rotulo: string;
  /** O valor já escrito. */
  valor: string;
}

/**
 * O total em destaque.
 *
 * @param rotulo - O texto de cima, em caixa alta.
 * @param valor - O valor escrito.
 * @returns O bloco centralizado.
 */
export function TotalEmDestaque({ rotulo, valor }: TotalEmDestaqueProps) {
  return (
    <div className="mb-2.5 text-center">
      <div className="mb-[3px] text-[10px] tracking-[0.5px] text-texto-fraco uppercase">
        {rotulo}
      </div>
      <div className="text-[22px] font-extrabold text-foreground">{valor}</div>
    </div>
  );
}
